import React, { useContext, useEffect, useState } from "react";
import QRCode from "qrcode.react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { Close, CropFree } from "@material-ui/icons";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import ContactsTheme from "../../pages/Contacts/theme";
const useStyles = makeStyles(theme => ({
 paper: { width: 440, maxWidth: "calc(100% - 24px)", margin: 12, borderRadius: 14 },
 title: { display: "flex", alignItems: "center", gap: 12, background: theme.crm.surface, borderBottom: "1px solid " + theme.crm.border, "& h2": { flex: 1, fontSize: 20, fontWeight: 700 } },
 content: { display: "flex", alignItems: "center", flexDirection: "column", gap: 20, padding: 24, background: theme.crm.background },
 qr: { background: "#fff", padding: 16, borderRadius: 12, maxWidth: "100%", boxSizing: "border-box", "& canvas": { maxWidth: "100%", height: "auto !important", display: "block" } },
 waiting: { minHeight: 220, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 18 },
 hint: { fontSize: 13, color: theme.crm.muted, lineHeight: 1.6 }
}));
function QrEditor({ open, onClose, whatsAppId, adminMode = false, companyId }) {
 const classes = useStyles();
 const { user, socket } = useContext(AuthContext);
 const [qrCode, setQrCode] = useState("");
 const [error, setError] = useState(false), [disconnected, setDisconnected] = useState(false), [revision, setRevision] = useState(0);
 useEffect(() => {
  if (!open || !whatsAppId) return undefined;
  let active = true, receivedEvent = false, timer;
  const poll = adminMode || typeof socket?.on !== "function";
  const cancel = axios.CancelToken.source();
  setQrCode(""); setError(false); setDisconnected(false);
  const update = data => {
   if (!active) return;
   if (data.status === "CONNECTED") { active = false; onClose(); return; }
   setQrCode(data.qrcode || ""); setDisconnected(data.status === "DISCONNECTED" || data.status === "TIMEOUT"); setError(false);
  };
  const handler = data => {
   if (data.action !== "update" || String(data.session?.id) !== String(whatsAppId)) return;
   receivedEvent = true; update(data.session);
  };
  const event = `company-${companyId || user.companyId}-whatsappSession`;
  const canSubscribe = !adminMode && typeof socket?.on === "function" && typeof socket?.off === "function";
  if (canSubscribe) socket.on(event, handler);
  const read = () => {
   if (!active) return;
   if (document.hidden && poll) { timer = setTimeout(read, 4000); return; }
   api.get((adminMode ? "/whatsapp-admin/" : "/whatsapp/") + whatsAppId, { cancelToken: cancel.token, timeout: 20000 })
    .then(({ data }) => { if (!receivedEvent) update(data); })
    .catch(err => { if (active && !receivedEvent && !axios.isCancel(err)) { setQrCode(""); setError(true); } })
    .finally(() => { if (active && poll) timer = setTimeout(read, 4000); });
  };
  read();
  return () => { active = false; clearTimeout(timer); cancel.cancel(); if (canSubscribe) socket.off(event, handler); };
 }, [open, whatsAppId, user.companyId, socket, onClose, revision, adminMode, companyId]);
 return <Dialog open={open} onClose={onClose} maxWidth={false} classes={{ paper: classes.paper }} aria-labelledby="connection-qr-title">
  <DialogTitle disableTypography className={classes.title}><CropFree /><Typography component="h2" id="connection-qr-title">Conectar WhatsApp</Typography><IconButton aria-label="Fechar QR code" onClick={onClose}><Close /></IconButton></DialogTitle>
  <DialogContent className={classes.content}>
   <Typography className={classes.hint}>No WhatsApp do celular, abra Aparelhos conectados → Conectar um aparelho.</Typography>
   {error ? <div className={classes.waiting}><Typography role="alert">Não foi possível carregar o QR code.</Typography><Button onClick={() => setRevision(v => v + 1)}>Tentar novamente</Button></div> : qrCode ? <div className={classes.qr} role="img" aria-label="QR code para conectar o WhatsApp"><QRCode value={qrCode} size={280} includeMargin /></div> : <div className={classes.waiting}>{!disconnected && <CircularProgress size={28} />}<Typography role="status">{disconnected ? "Sessão desconectada. Gere um novo QR code na conexão." : "Aguardando QR code…"}</Typography></div>}
  </DialogContent><DialogActions><Button onClick={onClose}>Fechar</Button></DialogActions>
 </Dialog>;
}
export default function QrcodeModal(props) { return <ContactsTheme><QrEditor {...props} /></ContactsTheme>; }